import { Route } from 'react-router-dom';
import { PresentationDetailPage } from './pages/PresentationDetailPage.js';
import { PresentationListPage } from './pages/PresentationListPage.js';

/**
 * Presentation — list + dynamic detail. Reuses the scenarios feed
 * today; Phase B may introduce a curated `/presentations` engine
 * resource for hand-built decks.
 */
export function presentationRoutes(): JSX.Element {
  return (
    <>
      <Route path="/presentation" element={<PresentationListPage />} />
      <Route path="/presentation/:presentationId" element={<PresentationDetailPage />} />
    </>
  );
}
